import React, { useEffect, useState } from 'react';
import 'intro.js/introjs.css';
import { Steps } from 'intro.js-react';
import step1Img from '../../../../assets/images/tour/Welcome_to_taletree.svg';
import lastImg from '../../../../assets/images/tour/last_step.svg';
import myCampImg from '../../../../assets/images/tour/My_camp.svg';
import commonRoomImg from '../../../../assets/images/tour/common_room.svg';
import setChallengeImg from '../../../../assets/images/tour/set_challenge.svg';
import kidInsightsImg from '../../../../assets/images/tour/kid_Insights.svg';
import addGuardianImg from '../../../../assets/images/tour/add_guardian.svg';
import captainTribeActivityImg from '../../../../assets/images/tour/captain_tribe_activities.svg';
import './customTourStyles.css'; // You'll define custom styles here
import { useAuth } from '../../../auth/Auth';
import { useHistory, useLocation } from 'react-router-dom';
import {
  currentStepsAtom,
  stepsEnabledAtom,
} from '../../../../atoms/camp.atom';
import { useRecoilState } from 'recoil';
import { useMediaQuery, useTheme } from '@mui/material';

const CampCaptainTour = ({ tribesList }) => {
  const [currentStep, setCurrentStep] = useRecoilState(currentStepsAtom); // Track the current step
  const { school } = useAuth();
  const history = useHistory();
  const location = useLocation();
  const [stepsEnabled, setStepsEnabled] = useRecoilState(stepsEnabledAtom);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const steps = [
    {
      element: '#step-one',
      intro: `
        <div class="custom-tour-step">
          <img src="${step1Img}" alt="Camp Master" class="tour-avatar" />
          <h3>Welcome to TaleTree, ${school?.first_name}!</h3>
          <p>You’ve been assigned as a Camp Captain! <br/>Your camp is on the premium plan giving you full access to TaleTree Village.</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip', // Custom tooltip class for CSS
      highlightClass: 'custom-highlight', // Custom highlight class for step highlighting
    },
    {
      element: '#captain-step-two',
      intro: `
        <div class="custom-tour-step">
          <img src="${captainTribeActivityImg}" alt="Camp Master" class="tour-avatar" />
          <h3>Dashboard</h3>
          <p>See all tribes and related events, view and write notes to guardians and see real-time activities from your tribe kids.</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip',
      highlightClass: 'custom-highlight',
    },
    {
      element: '#captain-step-commonroom',
      intro: `
        <div class="custom-tour-step">
          <img src="${commonRoomImg}" alt="Camp Master" class="tour-avatar" />
          <h3>Common Room</h3>
          <p>Your camp has a common room where all tribes gather. Here you can see each kid and their room and all local challenges set and creations that have been submitted by the kids in your tribe.</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip custom-tooltip-common-room',
      highlightClass: 'custom-highlight',
    },
    {
      element: '#captain-step-setchallenge',
      intro: `
        <div class="custom-tour-step">
          <img src="${setChallengeImg}" alt="Camp Master" class="tour-avatar" />
          <h3>Set Challenges</h3>
          <p>As Captain, you can set challenges for your tribe.</p>
        </div>`,
      position: 'left',
      tooltipClass: 'custom-tooltip custom-tooltip-common-room',
      highlightClass: 'custom-highlight',
    },
    {
      element: '#captain-step-mycamp',
      intro: `
        <div class="custom-tour-step">
          <img src="${kidInsightsImg}" alt="Camp Master" class="tour-avatar" />
          <h3>My Camp</h3>
          <p>A list of all kids and their activation status. Invite guardians from here and view each kid's insights.</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip custom-tooltip-common-room',
      highlightClass: 'custom-highlight',
    },
    {
      element: '#captain-step-moredetails',
      intro: `
        <div class="custom-tour-step">
          <img src="${kidInsightsImg}" alt="Camp Master" class="tour-avatar" />
          <h3>My Camp</h3>
          <p>To view the children's insights, including challenges, check-ins, and events, tap the 'More Details' section.</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip custom-tooltip-common-room',
      highlightClass: 'custom-highlight',
    },
    {
      element: '#captain-step-invite',
      intro: `
        <div class="custom-tour-step">
          <img src="${addGuardianImg}" alt="Camp Master" class="tour-avatar" />
          <h3>Invite Guardians</h3>
          <p>It’s time to bring parents on board! Click the "Invite Guardians" button from your “dashboard” or “my camp” to send out invitations to guardians. They’ll be able to activate their child’s account and monitor activities and generate insights to help with their 20-minute promise as they play their part.</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip custom-tooltip-common-room',
      highlightClass: 'custom-highlight',
    },
    {
      element: '#captain-step-three',
      intro: `
        <div class="custom-tour-step">
          <img src="${myCampImg}" alt="Camp Master" class="tour-avatar" />
          <h3>Meet Your Tribe</h3>
          <p>${
            tribesList.length > 1
              ? `You’re now leading the Tribe ${tribesList[1].name}! `
              : ''
          }View the members of your tribe by clicking on the “My Camp” to see their insights and activities and “Common Room” to see ROOM which has been connected to your common room.</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip custom-tooltip-common-room',
      highlightClass: 'custom-highlight',
    },
    {
      element: '#captain-step-viewactivity',
      intro: `
        <div class="custom-tour-step">
          <img src="${lastImg}" alt="Camp Master" class="tour-avatar" />
          <h3>Monitor Tribe Activities</h3>
          <p>Keep track of all the creative activities across your camp. Select a tribe from the dropdown menu in your calendar and then click "View Activites” and from there you can access a real-time feed of updates and interactions across the tribe.</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip custom-tooltip-common-room',
      highlightClass: 'custom-highlight',
    },
    {
      element: '#captain-step-two',
      intro: `
        <div class="custom-tour-step">
          <img src="${lastImg}" alt="Camp Master" class="tour-avatar" />
          <h3>Lead your camp!</h3>
          <p>You’re now fully equipped to lead your camp! Let’s create something special together at TaleTree.</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip custom-tooltip-common-room',
      highlightClass: 'custom-highlight',
    },
  ];

  // Function to wait for the element to appear
  const waitForElement = (
    selector,
    callback,
    interval = 100,
    timeout = 5000
  ) => {
    const startTime = new Date().getTime();
    const check = setInterval(() => {
      if (document.querySelector(selector)) {
        clearInterval(check);
        callback();
      } else if (new Date().getTime() - startTime > timeout) {
        clearInterval(check); // Timeout to avoid infinite loop
      }
    }, interval);
  };

  useEffect(() => {
    const handleNavigation = () => {
      switch (currentStep) {
        case 2:
          if (location.pathname !== '/camp/camp-challenges') {
            history.push('/camp/camp-challenges');
          }
          break;
        case 4:
          if (location.pathname !== '/camp/kids') {
            history.push('/camp/kids');
          }
          break;
        case 6:
          if (location.pathname !== '/camp/camp-room') {
            history.push('/camp/camp-room');
          }
          break;
        case 1:
          if (location.pathname !== '/camp/camp-room') {
            history.push('/camp/camp-room');
          }
          break;
        case 3:
          if (location.pathname !== '/camp/camp-challenges') {
            history.push('/camp/camp-challenges');
          }
          break;
        case 5:
          if (location.pathname !== '/camp/kids') {
            history.push('/camp/kids');
          }
          break;
        default:
          break;
      }
    };

    handleNavigation();

    // Wait for the element to appear before starting the tour
    if (stepsEnabled) {
      const stepSelector = steps[currentStep].element;
      waitForElement(stepSelector, () => setStepsEnabled(true));
    }
  }, [currentStep, history, location.pathname, stepsEnabled]);

  const handleStepChange = (stepIndex) => {
    setCurrentStep(stepIndex); // Track current step
  };

  const handleExit = () => {
    setStepsEnabled(false);
  };

  return (
    <Steps
      enabled={stepsEnabled}
      steps={steps}
      initialStep={currentStep} // This ensures it starts from the current step
      onExit={handleExit} // Handle exit to disable tour
      onChange={handleStepChange} // Track the current step
      options={{
        hidePrev: true,
        doneLabel: 'Close', // Customize the done button
      }}
    />
  );
};

export default CampCaptainTour;
